import React, { useMemo } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url, URLS } from '@wix/da-url';
import EllipsisIcon from '../../../Icons/Ellipsis';
import IconButtonWithContextMenu from '../../../Dropdown/Preset/IconButtonWithContextMenu';
import { BiEventType } from '../../../biLogger/constants';
import NewIndicatorDot from '../../../NewIndicatorDot';
import moreMenuStyles from './MoreMenu.scss';
var MoreMenu = function (_a) {
    var className = _a.className, iconClassName = _a.iconClassName, hasNewContent = _a.hasNewContent, markMoreMenuSeen = _a.markMoreMenuSeen;
    var t = useTranslation().t;
    var items = useMemo(function () { return [
        {
            key: 'groups',
            label: t('siteHeader.groups'),
            link: Url.buildFromPath(URLS.GROUPS),
            biData: {
                evid: BiEventType.TOP_NAV_CLICK,
                link_name: 'groups',
                link_url: Url.buildFromPath(URLS.GROUPS),
            },
        },
        {
            key: 'shop',
            label: t('siteHeader.shop'),
            link: Url.buildFromPath(URLS.SHOP),
            biData: {
                evid: BiEventType.TOP_NAV_CLICK,
                link_name: 'shop',
                link_url: Url.buildFromPath(URLS.SHOP),
            },
        },
        {
            key: 'forum',
            label: t('siteHeader.forum'),
            link: Url.buildFromPath(URLS.FORUM),
            biData: {
                evid: BiEventType.TOP_NAV_CLICK,
                link_name: 'forum',
                link_url: Url.buildFromPath(URLS.FORUM),
            },
        },
        {
            key: 'corelounge',
            label: t('siteHeader.coreLounge'),
            link: Url.userLink('corelounge'),
            biData: {
                evid: BiEventType.TOP_NAV_CLICK,
                link_name: 'corelounge',
                link: Url.userLink('corelounge'),
            },
        },
        {
            key: 'artStore',
            label: t('siteHeader.artStore'),
            newTag: true,
            link: URLS.ART_STORE,
            target: '_blank',
            biData: {
                evid: BiEventType.TOP_NAV_CLICK,
                link_name: 'artStore',
                link_url: URLS.ART_STORE,
            },
        },
    ]; }, [t]);
    return (React.createElement(IconButtonWithContextMenu, { items: items, className: c(moreMenuStyles['root'], className), popperClassName: moreMenuStyles['popper'], "aria-label": t('siteHeader.more'), onOpen: markMoreMenuSeen },
        React.createElement(EllipsisIcon, { className: iconClassName, disableDefaultColors: true }),
        hasNewContent && (React.createElement(NewIndicatorDot, { className: moreMenuStyles['new-indicator-dot'] }))));
};
MoreMenu.displayName = 'MoreMenu';
export default MoreMenu;
//# sourceMappingURL=MoreMenu.js.map